import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const DataContext = React.createContext({});

const AppStateProvider = DataContext.Provider;

const DataContextProvider = ({ children }) => {
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [selectedFromList, setSelectedFromList] = useState();
    const [selectedArea, setSelectedArea] = useState();
    const [selectedCenter, setSelectedCenter] = useState();
    const [selectedFeatureMatches, setSelectedFeatureMatches ] = useState();
    const [loading, setLoading] = useState(false);
    const [flikDataHidden, setFlikDataHidden] = useState(false);
    const [showFlikDataFill, setShowFlikDataFill] = useState(true);
    const [flikDataOpacity, setFlikDataOpacity] = useState(0.4);
    const [protectedAreaHidden, setProtectedAreaHidden] = useState(true);
    const [GLöZ2AreasHidden, setGLöZ2AreasHidden] = useState(false);
    const [protecteAreasOpacity, setProtecteAreasOpacity] = useState(0.6);
    const [protecteAreasLabels, setProtecteAreasLabels] = useState(true);
    const [GLöZ2AreasOpacity, SetGLöZ2AreasOpacity] = useState(0.6);
    const [NUT2Hidden, setNUT2Hidden] = useState(true);
    const [NUT2Opacity, setNUT2Opacity] = useState(0.6);
    const [showHDWms, setShowHDWms] = useState(true);
    const [glossar, setGlossar] = useState();


    //load landuse Glossar
    useEffect(() => {
        fetch("./glossar.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((json) => setGlossar(json));
    }, []);

    const value = {
        selectedFromList,
        setSelectedFromList,
        selectedFeatures,
        setSelectedFeatures,
        selectedArea,
        setSelectedArea,
        selectedCenter, 
        setSelectedCenter,
        selectedFeatureMatches, 
        setSelectedFeatureMatches, 
        loading,
        setLoading,
        flikDataHidden,
        setFlikDataHidden,
        showFlikDataFill,
        setShowFlikDataFill,
        flikDataOpacity,
        setFlikDataOpacity,
        protectedAreaHidden,
        setProtectedAreaHidden,
        GLöZ2AreasHidden,
        setGLöZ2AreasHidden,
        protecteAreasOpacity,
        showHDWms,
        setShowHDWms,
        setProtecteAreasOpacity,
        protecteAreasLabels,
        setProtecteAreasLabels,
        GLöZ2AreasOpacity,
        SetGLöZ2AreasOpacity,        
        NUT2Hidden,
        setNUT2Hidden,
        NUT2Opacity,
        setNUT2Opacity,
        glossar,
    };

    return <AppStateProvider value={value}>{children}</AppStateProvider>;
};

DataContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export { DataContext, DataContextProvider };
